import { render } from "./PredictionInput.vue?vue&type=template&id=5d974346"
import script from "./PredictionInput.vue?vue&type=script&lang=js"
export * from "./PredictionInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/adelaplace/PycharmProjects/smartcast/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__